import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { FlexColumn } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';
import { noop } from 'ui-components/default-props/noop';

import { useAddOnsActionContext } from './add-ons-action-context';
import { ADD_ONS_WITH_SETTINGS } from './constants';
import messages from './messages';
import style from './style.module.less';
import EmptyBoxIcon from '../../../svgs/empty-box.svg';
import { AddOnTile } from '../components/add-on-tile';
import { SettingsPageTitle } from '../components/settings-page-title/settings-page-title';

export const AddOnMarketplace = () => {
  const {
    addOnCodeWithError,
    setAddOnCodeWithError,
    onClickActivateAddOn,
    enabledAddons,
    disabledAddons,
    onClickDeactivateAddon,
    onClickManageSettings,
  } = useAddOnsActionContext();

  return (
    <FlexColumn className={style['addons-page-content']}>
      <div className={style['addons-wrapper']}>
        <SettingsPageTitle value={messages.addOnMarketplace} />
        <Text textType={TextType.Paragraph} value={messages.addOnMarketplaceDescription} />
        {disabledAddons.length > 0 && (
          <>
            <Text className={style['grid-header']} textType={TextType.H2} value={<FormattedMessage {...messages.addOnsHeader} />} />
            <div className={style['addon-grid']}>
              {disabledAddons.length !== 0 &&
                disabledAddons.map((addOn) => (
                  <AddOnTile
                    key={addOn.code}
                    addOn={addOn}
                    addOnWithError={addOnCodeWithError}
                    handleCloseAddOnErrorMessage={setAddOnCodeWithError}
                    isAvailable
                    onClickAddAddon={onClickActivateAddOn}
                  />
                ))}
            </div>
          </>
        )}
        <Text className={style['grid-header']} textType={TextType.H2} value={<FormattedMessage {...messages.yourAddOnsHeader} />} />
        <div
          className={classnames(style['addon-grid'], {
            [style.empty]: enabledAddons.length === 0,
          })}
        >
          {enabledAddons.length === 0 && (
            <>
              <div className={style['placeholder-image']}>
                <img alt='empty box' className={style['empty-box']} src={EmptyBoxIcon} />
              </div>
              <Text
                className={style['empty-header']}
                textType={TextType.Description}
                value={<FormattedMessage {...messages.noActiveAddOnsHeader} />}
              />
              <Text
                className={style['empty-note']}
                textType={TextType.Paragraph}
                value={<FormattedMessage {...messages.noActiveAddOnsDescription} />}
              />
            </>
          )}
          {enabledAddons.length !== 0 &&
            enabledAddons.map((addOn) => {
              return (
                <AddOnTile
                  key={addOn.code}
                  addOn={addOn}
                  addOnWithError={addOnCodeWithError}
                  handleCloseAddOnErrorMessage={setAddOnCodeWithError}
                  onClickAddAddon={onClickActivateAddOn}
                  onClickDeactivate={onClickDeactivateAddon}
                  onClickManageSettings={ADD_ONS_WITH_SETTINGS.includes(addOn.code) ? onClickManageSettings : noop}
                />
              );
            })}
        </div>
      </div>
    </FlexColumn>
  );
};
